
import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";
import { SectionTitle } from "@/components/SectionTitle";
import { PageTitle } from "@/components/PageTitle";

const TermsOfService = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <PageTitle title="Terms of Service – Asrani Dental Clinic" />
      <Header />
      <main className="flex-grow">
        <div className="container-custom py-12 md:py-16">
          <SectionTitle
            title="Terms of Service"
            subtitle="Last Updated: May, 2023"
            alignment="left"
          />
          
          <div className="prose prose-lg max-w-none mt-8">
            <p className="text-gray-600">
              Welcome to Asrani Dental Clinic. These Terms of Service ("Terms") govern your use of our website and services. Please read these Terms carefully before using our website or services.
            </p>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Acceptance of Terms</h2>
            
            <p className="text-gray-600">
              By accessing or using our website and services, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use our website or services.
            </p>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Services</h2>
            
            <p className="text-gray-600">
              Asrani Dental Clinic provides dental services, including but not limited to general dentistry, cosmetic dentistry, orthodontics, dental implants, teeth whitening, and pediatric dentistry. Our website provides information about these services and allows you to schedule appointments.
            </p>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Appointment Scheduling and Cancellation</h2>
            
            <p className="text-gray-600">
              You can schedule appointments through our website, by phone, or in person. If you need to cancel or reschedule an appointment, please provide at least 24 hours' notice. Failure to provide adequate notice may result in a cancellation fee.
            </p>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Payment Terms</h2>
            
            <p className="text-gray-600">
              Payment for our services is due at the time of service unless other arrangements have been made in advance. We accept various payment methods, including cash, credit cards, and approved insurance plans. For insurance claims, you are responsible for any portion of the charges not covered by your insurance.
            </p>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Website Use</h2>
            
            <p className="text-gray-600">
              You may use our website for lawful purposes only. You agree not to:
            </p>
            
            <ul className="list-disc ml-6 text-gray-600 space-y-2 mt-4">
              <li>Use our website in any way that violates applicable laws or regulations</li>
              <li>Attempt to gain unauthorized access to our website, servers, or databases</li>
              <li>Interfere with the proper functioning of our website</li>
              <li>Collect or harvest any information from our website without our permission</li>
            </ul>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Intellectual Property</h2>
            
            <p className="text-gray-600">
              All content on our website, including text, graphics, logos, images, and software, is our property or the property of our licensors and is protected by copyright and other intellectual property laws. You may not use, reproduce, distribute, or modify any content from our website without our express written permission.
            </p>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Disclaimer of Warranties</h2>
            
            <p className="text-gray-600">
              Our website and services are provided "as is" and "as available" without any warranties of any kind, express or implied. We do not guarantee that our website will be error-free, secure, or uninterrupted.
            </p>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Limitation of Liability</h2>
            
            <p className="text-gray-600">
              To the fullest extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of our website or services.
            </p>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Changes to Terms</h2>
            
            <p className="text-gray-600">
              We may update these Terms from time to time. The updated version will be effective as soon as it is posted on our website. Your continued use of our website and services after any changes indicates your acceptance of the updated Terms.
            </p>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Governing Law</h2>
            
            <p className="text-gray-600">
              These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.
            </p>
            
            <h2 className="text-2xl font-serif font-medium mt-8 mb-4 text-gray-800">Contact Us</h2>
            
            <p className="text-gray-600">
              If you have any questions or concerns about these Terms, please contact us at:
            </p>
            
            <p className="text-gray-600 mt-4">
              <strong>Asrani Dental Clinic</strong><br />
              Email: asranisbdental@gmail.com<br />
              Phone: +91 8010224989
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
